/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {GetInstrumentCapabilityConfigRequest} from '@cash-web/protos/squareup/cash/out/api/v1_0/GetInstrumentCapabilityConfig.pb'
import {GetInstrumentCapabilityConfigResponse} from '@cash-web/protos/squareup/cash/out/api/v1_0/GetInstrumentCapabilityConfig.pb'


export const getInstrumentCapabilityConfig = (request: GetInstrumentCapabilityConfigRequest, options?: CashRequestOptions) => post<GetInstrumentCapabilityConfigRequest, GetInstrumentCapabilityConfigResponse>("/2.0/cash/get-instrument-capability-config", request, {...options, rejectOnError: true })